/** @prettier */

import {useDragLayer} from 'react-dnd/dist/hooks/useDragLayer';

export const useDragPreview = () => {
  const {item, isDragging, initialOffset, differenceOffset} = useDragLayer(
    (monitor: {
      getSourceClientOffset: () => any;
      getDifferenceFromInitialOffset: () => any;
      getItem: () => any;
      isDragging: () => boolean;
    }) => ({
      //ドラッグしているアイテムの初期位置を取得
      initialOffset: monitor.getSourceClientOffset(),
      //ドラッグ開始位置から現在のカーソル位置までの差分を取得
      differenceOffset: monitor.getDifferenceFromInitialOffset(),
      //useDragのItemに渡していた要素をここから取得
      item: monitor.getItem(),
      isDragging: monitor.isDragging(),
    })
  );

  if (
    isDragging === false ||
    differenceOffset === false ||
    initialOffset === false
  ) {
    return {isDragging: isDragging, x: 0, y: 0, unitName: '', unitID: ''};
  }
  return {
    isDragging: isDragging,
    //以下でプレビューを表示したい座標を計算
    //absoluteを使用しているので、現在表示されている座標から、カーソル移動量(differenceOffset)を加算する
    x: item.left + differenceOffset.x,
    y: item.top + differenceOffset.y,
    unitName: item.unitName,
    unitID: item.id,
  };
};
